// Exportacion a Excel de verdad (.xlsx).
//
// POR QUE NO BASTABA EL CSV. Un CSV no dice de que tipo es cada celda,
// asi que Excel lo adivina al abrirlo — en la maquina del contador, no en
// la nuestra, de modo que nadie de este lado ve el destrozo:
//   * el codigo de barras 7501234567890 se convierte en 7.50123E+12;
//   * el SKU 0012345 pierde los ceros y ya no casa con nada;
//   * el numero de parte 05-2024 se lee como mayo de 2024;
//   * las cantidades llegan como texto y la suma de Excel da cero.
// En un .xlsx el tipo va DECLARADO en la celda y no hay nada que adivinar.
//
// EL ARCHIVO LO ESCRIBE EL SERVIDOR. Aqui solo se arma la matriz y se
// manda: escribir un xlsx en el navegador significaria implementar zip y
// XML a mano, sin una sola prueba que lo cubra (la suite de este proyecto
// es de backend). Del lado del servidor son treinta pruebas.
import { api } from '../api';
import { guardarArchivo } from './descarga';

// Le da tipo a cada columna para la hoja de calculo.
//
// El tipo NO se infiere del contenido del texto —eso es exactamente lo
// que hace Excel y es el error que se viene a corregir—: se toma del tipo
// de dato que la columna ya devuelve. Si `valor()` devuelve un number,
// es un numero; si devuelve una cadena, es texto, aunque la cadena sean
// puros digitos. Un SKU no es una cantidad.
//
// Para fechas e importes no hay forma de saberlo solo por el tipo (ambos
// llegan como cadena y como number respectivamente), asi que la columna
// lo declara: `tipo: 'fecha' | 'fecha_hora' | 'moneda'`.
function tipoDeColumna(col, filas) {
  if (col.tipo) return col.tipo;

  let algunNumero = false;
  for (const f of filas) {
    const v = col.valor(f);
    if (v == null || v === '') continue;
    if (typeof v !== 'number') return 'texto';
    algunNumero = true;
  }
  return algunNumero ? 'numero' : 'texto';
}

// Las marcas de tiempo del servidor vienen en UTC, y la pantalla las
// pinta en la hora del navegador. Si se mandaran tal cual, la hoja
// diria otra hora que la pantalla: una venta de las 19:00 del 31
// aparecia a la 01:00 del 1, y con ella se movia de mes el corte.
//
// Una fecha SIN hora (una caducidad, `2026-08-05`) no se convierte: no
// tiene zona que ajustar, y pasarla por Date la interpretaria como
// medianoche UTC, que en Mexico es el dia anterior.
function aHoraLocal(valor) {
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return valor;
  const dd = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${dd(d.getMonth() + 1)}-${dd(d.getDate())}`
       + `T${dd(d.getHours())}:${dd(d.getMinutes())}:${dd(d.getSeconds())}`;
}

export async function exportarXLSX(nombreArchivo, columnas, filas, pie) {
  const tipos = columnas.map((c) => tipoDeColumna(c, filas));

  const blob = await api.descargar('/exportar/xlsx', {
    nombre: nombreArchivo,
    columnas: columnas.map((c, i) => ({ etiqueta: c.etiqueta, tipo: tipos[i] })),
    filas: filas.map((f) => columnas.map((c, i) => {
      const v = c.valor(f);
      if (v == null || v === '') return null;
      return tipos[i] === 'fecha_hora' ? aHoraLocal(v) : v;
    })),
    ...(pie ? { pie } : {}),
  });

  guardarArchivo(blob, `${nombreArchivo}.xlsx`);
}
